<template>
  <div class="container mb-5">
    <div class="row mb-5 my-md-5">
      <div class="col-sm-6 offset-sm-3">
        <h1 class="text-center">
          {{ $t("graficoDeVendas") }}
        </h1>
      </div>
    </div>
    <VisionTwoCharts />
  </div>
</template>

<script>
import VisionTwoCharts from './components/VisionTwoCharts.vue';

export default {
  components: { VisionTwoCharts },
};
</script>
